module.exports = __webpack_public_path__ + "img/title6_3.44edf22c.png";